import { useSetAtom } from 'jotai'
import React from 'react'
import { useTranslation } from 'react-i18next'

import {
  StyledButton,
  type StyledButtonProps,
} from '~/components/elements/StyledButton'

import { dialogInfoAtom } from '../atoms'
import { type BrandAccountUser } from '../hooks'

export type EditButtonProps = {
  dataItem: BrandAccountUser
}

export const EditButton = ({ dataItem: brandAccountUser }: EditButtonProps) => {
  const { t } = useTranslation()
  const setDialogInfo = useSetAtom(dialogInfoAtom)

  const handleEditButtonClick = React.useCallback<
    EH<StyledButtonProps, 'onClick'>
  >(() => {
    setDialogInfo({ brandAccountUser, dialogType: 'edit' })
  }, [brandAccountUser, setDialogInfo])

  return (
    <StyledButton
      fillMode="outline"
      icon="wrench"
      onClick={handleEditButtonClick}
    >
      {t('change')}
    </StyledButton>
  )
}
